<!-- unsused -->
<template>
    <div id="Orders">
        <div class="title">
            <div class="bar">您有以下未支付订单</div>
            <div class="cont">以下订单后付清后即可完成解绑</div>
        </div>
        <div class="item-group">
            <div class="item" v-for="(item, index) in orders" :key='index'>
                <div class="bus">{{item.business_name}}</div>
                <div class="date">{{item.create_time}}</div>
                <div class="from">{{item.from_name}}</div>
                <div class="to">{{item.to_name}}</div>
                <div class="money">
                    <span class="number">{{item.p_total_fee}}</span>
                </div>
                <div class="shensu">费用异议</div>
                <div class="btn" @click="goPay(item)">去支付</div>
            </div>
        </div>
        <footer>以上均不是我的订单
        <a class="orange" v-if="env === 'passenger'" href="tel:4000000999">联系客服</a>
        <a class="orange" v-if="env === 'driver'" href="tel:4000000666">联系客服</a>
        </footer>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['orders', 'verifyData', 'env'])
  },
  methods: {
    goPay (_item) {
      console.log(this.verifyData)
      let params = {
        oid: _item.encode_oid,
        bid: _item.product_id,
        token: this.verifyData
      }
      console.log(window.D.bridge.app.system)
      window.D.bridge.openUniPay(params, (res) => {
        alert(res)
      })
      window.D.bridge.call('sendPayResult', (res) => {
        console.log('sendPayResult', res)
      })
    }
  },
  components: {
  }
}
</script>
<style lang="scss">
@import '~common-css/func.scss';

#Orders{
    background:#fff;
    .title{
        padding:px2rem(48) px2rem(96) 0 px2rem(96);
        .bar{
            font-size:px2rem(48);
            line-height:px2rem(67);
        }
        .cont{
            font-size:px2rem(28);
        }
    }
    .orange{
        color: #E3662B;
    }
    .item-group{
        width:px2rem(600);
        margin:px2rem(120) px2rem(75) 0 px2rem(75);
        border-radius:2px;
        box-sizing:border-box;
        padding-bottom:px2rem(122);
        .item{
            border:1px solid #ccc;
            padding:px2rem(28);
            font-size: px2rem(28);
            color: #666;
            line-height: px2rem(28);
            margin-bottom:px2rem(20);
            .bus{
                color:#333;
            }
            .date{
                margin-top:px2rem(24);
                &::before{
                    content:'';
                    background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAdNJREFUSA21lj1Lw0AYx5uX1S9QHISCiN/AUXATLK7SRUo6Cv0E4odw6Bsu7lLBTXB0dXQpOEi/gGuT+v/FXLmkIUkxOUife+7+z++5y93l6rQKymQy2Vd3d71en8t2ZNvIHcdZyixkX2TnQRB8055XnLzG2WzWXq1WdwJcC+rlaUybNKE0D77v3/b7fRKnylaC8Xh8IcWjgvZSyhJHiX4k6Q0Gg2db6trOaDS6EfhpVzgMYoiFYTM3M2DkCNSZSmqLVX9P/JNMu+1Gms2lmUmcgHcehuFn2cg9zzuDJO2rTczWeV3SHrEm8WhZ0DI4EGlY0DALzPqwYNLusBXV8KWncLcgdl33FBtF0Ru2qLC79BwwA/Z5KbwIlteXMLuuKhyiRgpsZtBphP4H7fjKEh//qkl0Yj+0gPFamBgxjvXcG99Y2L5xqlgFXAleRbrR+FrppQIPNy0FFekCngJJqgs2a7BItdbrLFxl4ZPbSIHNDOaqlJ7OXUeQMOcul4Xe68OugDI9TNjMoMVloYx8z2spsGACixMkN1FPflRDBhg9c7vFCYAm3++hqv9JQuzQ3AVwHX7s0uiVSSKyc1moOq2yuxLNlBh75GbQWzMwHdg6/rb8Ar+i5yJp0hwQAAAAAElFTkSuQmCC');
                    width:px2rem(16);
                    height:px2rem(16);
                    display:inline-block;
                    background-size: contain;
                    margin-right:px2rem(18);
                    vertical-align:middle;
                    margin-top:px2rem(-14);
                }
            }
            .from{
                margin-top:px2rem(24);
                margin-left:0.8rem;
                width:px2rem(400);
                &::before{
                    content:'';
                    background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAANRJREFUOBHFktEJwkAMhi/ig47gDO6gclRcQqGgYykUdAmxFO0OzuAI+iDE+0sTUqE9fWpf7i75/v9yTZzr+6PvApiZFnm2Y3ZbIpoiH2J3Ine4Juk+xNhqGgar8jh5vt6nAHgLmX0xHg3X59nmIbGBbHBzRAzUgwErOjVA2QAk0bH6mq0QNcCbO0SNlGXVQH5Yg2w5WFYNWthoWA3QqihdA5ZVA/T5VwPLajvQmvkly4OJjxgVt2WayECZCogxJEFcdBhUgyRicFqBiFDJP6Msuv7WD37PVJlag72lAAAAAElFTkSuQmCC');
                    width:px2rem(16);
                    height:px2rem(16);
                    display:inline-block;
                    background-size: contain;
                    margin-right:px2rem(18);
                    vertical-align:middle;
                    margin-top:px2rem(-14);
                    margin-left:-0.8rem;
                }
            }
            .to{
                margin-top:px2rem(24);
                width:px2rem(300);
                margin-left:0.8rem;
                display:inline-block;
                &::before{
                    content:'';
                    background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAANVJREFUOBHFkr0NwjAQhf1IASswA1sgRoAuHUhUmYYKCbp0MALKFszAClBEhy/hnQ5w+Knixtb5e89n+4XQ98BrAyKCejNfBcESCBPdFwnnANlnxXEHQLzmyUC2+bi+XcuomHrI1kCVDUc51uWFtQEXzcmfxApGYz1AWerMoG2742TSNNErPoYZ6J1Z/Do71gz4YF/FEfCsGfwiTDFm0HxVikjUPGsG+s8JNl1yrH1HG6DFqTMDtNIsFIcZA2UdaEFDEl+oIvs2M0gujdYB4X+jTF1/8x3OdF0l1iIukgAAAABJRU5ErkJggg==');
                    width:px2rem(16);
                    height:px2rem(16);
                    display:inline-block;
                    background-size: contain;
                    margin-right:px2rem(18);
                    vertical-align:middle;
                    margin-top:px2rem(-14);
                    margin-left:-0.8rem;
                }
            }
            .money{
                display: inline-block;
                width:px2rem(160);
                text-align:right;
                margin-right:px2rem(20);
                .number{
                    font-size:px2rem(48);
                    color:#333;
                    &::after{
                        content:'元';
                        font-size:px2rem(24);
                        color:#666;
                    }
                }
            }
            .shensu{
                margin-left:px2rem(390);
                color:#999;
                padding-top:px2rem(16);
                &::after{
                    content:'';
                    background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAYBJREFUSA3tlD1Lw1AUhpuoRQQx8T90FUQQF4c6iIuDKAUFpUFMN138+AFuuoiLNmko6GD3LipiBv+Ba/+Em2JI4nPBQAjFcwuCCL0QTu7X856899yUSsP21w4YUgKtVmslSZLdNE23Go1GJK0vzpvFgWI/juM68A3DMO7CMBwtzkt9UcC27R0g94is93q9G6K4Jy8qLq7Vap/lcnmNL3gGvun7fkAUrc1ERAG10HGcD6CriLwQ657nXWcAKWpnokBBEExyJo+ILNC95NAPflVAwdrtthVF0RMic3TPETn+SUTLojwAu95M01zGrlfGj7DrND9ffB9YQAEQGCGMFWH9+gOdgQJw8aa5eCEWzfAVZ67rnvQDZ2MqE+3WbDanWKz8nyVe4P+htFlbQFUQ4AeeeaBXwPcluJrXsojMJ7BD3eZFYrBHI6Y6AuIhU5bjwLrf8FvYri5cJSAKUPMd4EtAO5ZlOcREJ/Nsjfh3pCQDqua9UqlsV6vVONs4jP/HgS+rWpOhKR1LBwAAAABJRU5ErkJggg==');
                    width:px2rem(24);
                    height:px2rem(24);
                    background-size:contain;
                    position: absolute;
                    margin-top:px2rem(1);
                }
            }
            .btn{
                height:px2rem(80);
                line-height:px2rem(80);
                margin-top:px2rem(20);
                background: #4A4C5B;
                border-radius: 4px;
                font-size: px2rem(28);
                color: #FFFFFF;
                text-align:center;
            }
        }

    }
    footer{
        position: absolute;
        bottom: px2rem(60);
        font-size: px2rem(24);
        color: #999;
        text-align: center;
        width: 100%;
    }

}

</style>
